import { QUERY } from '../utilities/network';
import { AdministratorType } from '../pages/settings';
import CONST from '../utilities/constant';

export interface MembershipType {
	id: number;
	type: string;
	valid_days: number;
}

class MembershipStore {
	types: Array<MembershipType> = [];
	invitationTypes: Array<MembershipType> = [];

	fetchMemberships = async () => {
		try {
			const data = await QUERY<{
				memberships: Array<MembershipType>;
				admin: { type: AdministratorType; company_id: number };
			}>(GET_MEMBERSHIP_TYPES);

			this.types = data.memberships;

			const { type, company_id } = data.admin;
			if (
				type === AdministratorType.God ||
				company_id === CONST.MI_COMPANY_ID ||
				company_id === CONST.MI_SALES_COMPANY_ID
			) {
				this.invitationTypes = this.types.filter(e => e.valid_days !== 0);
			} else {
				this.invitationTypes = this.types.filter(e => e.valid_days < 0);
			}
		} catch (e) {}
	};
}

const Membership = new MembershipStore();
export default Membership;

const GET_MEMBERSHIP_TYPES = `
query {
  memberships: membershipTypes {
    id
    type
    valid_days
  }
  admin: administratorInfo {
    type
    company_id
  }
}`;
